import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MobileNavService} from '@services/frontend/mobile-nav.service';
import {Header} from '@shared/components/header/header';
import {Sidebar} from '@shared/components/sidebar/sidebar';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [Header, Sidebar, RouterOutlet],
  templateUrl: './dashboard.html',
})
export class Dashboard {
  protected readonly mobileNav = inject(MobileNavService);
}
